import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import { StyledFooter, StyledWrapper } from "./Footer.styles";

export const DEFAULT_MESSAGE_1 = "Business sensitive information";
export const DEFAULT_MESSAGE_2 = "for internal use only.";

const Footer = ({
    message_1 = DEFAULT_MESSAGE_1,
    message_2 = DEFAULT_MESSAGE_2,
    children,
}) => {
    return (
        <StyledFooter className="footer">
            {children ?? (
                <StyledWrapper>
                    <Text variant="Descriptive_1_1" color="Gray_3">
                        {message_1}
                    </Text>
                    <Text variant="Descriptive_1_1" color="Gray_2">
                        {message_2}
                    </Text>
                </StyledWrapper>
            )}
        </StyledFooter>
    );
};

Footer.propTypes = {
    message_1: PropTypes.string,
    message_2: PropTypes.string,
    children: PropTypes.node,
};

export default Footer;
